import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { Helmet } from "react-helmet";

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();

  if (cartItems.length === 0) {
    return (
      <div className="cart-container">
        <div className="empty-cart">
          <div className="empty-cart-icon"><FaShoppingCart /></div>
          <h2>Il Tuo Carrello e Vuoto</h2>
          <p>Non hai ancora aggiunto nessun servizio al carrello.</p>
          <Link to="/" className="cta-button">Esplora i Nostri Servizi</Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div className="cart-container">
      <h1 className="page-title">Il Tuo Carrello</h1>
      
      <div className="cart-items">
        {cartItems.map(item => (
          <div key={item.id} className="cart-item">
            <img src={item.image} alt={item.name} className="cart-item-image" />
            
            <div className="cart-item-info">
              <h3>{item.name}</h3>
              <p className="cart-item-price">€{item.price.toFixed(2)}</p>
              
              <div className="quantity-controls">
                <button 
                  onClick={() => updateQuantity(item.id, item.quantity - 1)}
                  className="quantity-btn"
                >
                  -
                </button>
                <span className="quantity-display">{item.quantity}</span>
                <button 
                  onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  className="quantity-btn"
                >
                  +
                </button>
              </div>
            </div>

            <button 
              onClick={() => removeFromCart(item.id)}
              className="remove-btn"
            >
              Rimuovi
            </button>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <p className="cart-total">Totale: €{getCartTotal().toFixed(2)}</p>
        <Link to="/checkout" className="checkout-btn">
          Procedi al Pagamento
        </Link>
      </div>
    </div>
  
    </>);
}

export default Cart;